import styled from '@emotion/styled';

export const Badge = styled.span<{
  active: boolean;
  persistent?: boolean;
  bgColor?: 'primary' | 'secondary';
}>`
  display: ${({ persistent }) =>
    persistent ? 'flex' : 'none'}; // none: controlled by parent
  align-items: center;
  justify-content: center;
  background-color: ${({ bgColor }) =>
    bgColor === 'primary' ? '#6E4C7D' : '#636363'};
  border-radius: 8px;
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  padding: 0 8px;
  height: 16px;
`;
